"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisposeTrace = exports.disableDisposeTrace = exports.enableDisposeTrace = void 0;
var enableTracing = false;
function enableDisposeTrace() {
    enableTracing = true;
}
exports.enableDisposeTrace = enableDisposeTrace;
function disableDisposeTrace() {
    enableTracing = false;
}
exports.disableDisposeTrace = disableDisposeTrace;
/**
 * 用于输出清理日志
 */
var DisposeTrace = /** @class */ (function () {
    function DisposeTrace(name) {
        this.name = name;
        this._dep = [];
    }
    DisposeTrace.traceRoot = function (id) {
        return !enableTracing ? DisposeTrace._None : new DisposeTrace(id);
    };
    DisposeTrace.prototype.branch = function (id) {
        var child = new DisposeTrace(id);
        this._dep.push([id, child]);
        return child;
    };
    DisposeTrace.prototype.stop = function () {
        function printChild(n, trace) {
            var e_1, _a;
            var res = [];
            var prefix = new Array(n + 1).join('\t');
            try {
                for (var _b = __values(trace._dep), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var _d = __read(_c.value, 2), id = _d[0], child = _d[1];
                    if (child) {
                        res.push(prefix + "dispose -> " + id);
                        var nested = printChild(n + 1, child);
                        if (nested) {
                            res.push(nested);
                        }
                    }
                    else {
                        res.push(prefix + "dispose -> " + id);
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return res.join('\n');
        }
        var lines = ["dispose " + this.name, "" + printChild(1, this)];
        console.log(lines.join('\n'));
    };
    DisposeTrace._None = new (/** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            return _super.call(this, null) || this;
        }
        class_1.prototype.stop = function () { };
        class_1.prototype.branch = function () {
            return this;
        };
        return class_1;
    }(DisposeTrace)))();
    return DisposeTrace;
}());
exports.DisposeTrace = DisposeTrace;
//# sourceMappingURL=dispose-trace.js.map